import bb from 'blingblingjs';

const pageWrapper = bb('.js-el__page-wrapper')[0];

export function toggle(){
    pageWrapper.classList.toggle('--has-overlay')
}

export function show(){
    pageWrapper.classList.add('--has-overlay')
}

export function hide(){
    pageWrapper.classList.remove('--has-overlay')
}